import React from "react";

export default function Currency({ value = 0.0 }) {
  return (
    <span>
      <span>
        {parseFloat(value)
          .toFixed(2)
          .toString()
          .replace(".", ",")}
      </span>
      <span> &euro;</span>
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/Currency.js